import {
    CREATE_HSN_MASTER_FAILURE,
    CREATE_HSN_MASTER_REQUEST,
    CREATE_HSN_MASTER_SUCCESS,
    CREATE_USER_FORM_HSN_MASTER,
    DELETE_HSN_MASTER_FAILURE,
    DELETE_HSN_MASTER_REQUEST,
    DELETE_HSN_MASTER_SUCCESS,
    FETCH_HSN_LIST_FROM_HSN_MASTER_FAILURE,
    FETCH_HSN_LIST_FROM_HSN_MASTER_REQUEST,
    FETCH_HSN_LIST_FROM_HSN_MASTER_SUCCESS,
    FETCH_HSN_MASTER_FAILURE,
    FETCH_HSN_MASTER_REQUEST,
    FETCH_HSN_MASTER_SUCCESS,
    FETCH_SINGLE_HSN_MASTER_FAILURE,
    FETCH_SINGLE_HSN_MASTER_REQUEST,
    FETCH_SINGLE_HSN_MASTER_SUCCESS,
    HSN_MASTER_USERFORM_RESET,
    UPDATE_HSN_MASTER_FAILURE,
    UPDATE_HSN_MASTER_REQUEST,
    UPDATE_HSN_MASTER_SUCCESS
} from './hsnMaster.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

// FETCH HSN MASTER
export let fetchHSNMaster = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.hsnMasterGET}`,
        responseTypeRequest: FETCH_HSN_MASTER_REQUEST,
        responseTypeSuccess: FETCH_HSN_MASTER_SUCCESS,
        responseTypeFailure: FETCH_HSN_MASTER_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createHSNUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_HSN_MASTER, payload: { key, value } });
    };
};

//call property from property table
export let fetchHSNList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/36`,
        responseTypeRequest: FETCH_HSN_LIST_FROM_HSN_MASTER_REQUEST,
        responseTypeSuccess: FETCH_HSN_LIST_FROM_HSN_MASTER_SUCCESS,
        responseTypeFailure: FETCH_HSN_LIST_FROM_HSN_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE HSN MASTER
export let createHSNMaster = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKCategory: parseInt(formData.hsnCategory),
        fldSalesCode: formData.salesCode,
        fldJobworkCode: formData.jobWorkCode,
        fldSalesPct: parseFloat(formData.SalesPer),
        fldJobworkPct: parseFloat(formData.jobWorkPer),
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString()
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.hsnMasterPOST}`,
        responseTypeRequest: CREATE_HSN_MASTER_REQUEST,
        responseTypeSuccess: CREATE_HSN_MASTER_SUCCESS,
        responseTypeFailure: CREATE_HSN_MASTER_FAILURE,
        resetFormData: HSN_MASTER_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchHSNMaster()
    };
    return axiosCall(config);
};

// GET SINGLE HSN MASTER
export let getSingleHSNMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.hsnMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_HSN_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_HSN_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_HSN_MASTER_FAILURE,
        singlApiArray: [fetchHSNList()]
    };
    return axiosCall(config);
};

//UPDATE HSN MASTER
export let updateHSNMaster = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: id,
        fldFKCategory: parseInt(formData.hsnCategory),
        fldSalesCode: formData.salesCode,
        fldJobworkCode: formData.jobWorkCode,
        fldSalesPct: parseFloat(formData.SalesPer),
        fldJobworkPct: parseFloat(formData.jobWorkPer),
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString()
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.hsnMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_HSN_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_HSN_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_HSN_MASTER_FAILURE,
        resetFormData: HSN_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchHSNMaster()
    };
    return axiosCall(config);
};

// DELETE HSN MASTER
export let deleteHSNMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.hsnMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_HSN_MASTER_REQUEST,
        responseTypeSuccess: DELETE_HSN_MASTER_SUCCESS,
        responseTypeFailure: DELETE_HSN_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchHSNMaster()
    };
    return axiosCall(config);
};
